define([
	"dojo/_base/lang",
	"dijit/CheckedMenuItem",
	"dijit/MenuItem",
	"dijit/MenuSeparator",
	"csi/_base/underscore",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/reflection",
	"csi/view/PluginFactory",
	"csi/view/ToolbarDropDown",
	"csi/widget/Menu",
	"csi/xml",
	"./ActionImage"
], function(lang, CheckedMenuItem, MenuItem, MenuSeparator, _, html, csiImage, locale, reflection, PluginFactory, ToolbarDropDown, Menu, xml, ActionImage) {

	var IMAGE_LABEL_ATTR = html.registerDataAttribute("DATA_IMAGE_LABEL", "image-label");
	var IMAGE_LABEL_CLEAR = "false";

	return PluginFactory.declare("imageLabel", ToolbarDropDown, {
		constructor: function() {
			this.defAction = lang.mixin(new ActionImage(), {
				m_id: "PropertyImageLabel",
				m_accessAction: function(ctx, action) {
					return ctx.view.getCurrentImageKey();
				}
			});
			this.defAction.setMaterialIcon("label_outline");
			this.defAction.resolve();
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: only show if class in context is an image container
			return ctx.view.imageLabelStore && !ctx.isReadOnly();
		},

		enablePlugin: function(/*Context?*/ctx) {
			const view = ctx?.view;
			const labels = view?.getCurrentImageLabels() || [];

			if (view) {
				const viewNode = view.getViewNode();
				const imageNode = view.getImageContainer();
				const bDefault = csiImage.getDefaultImage(imageNode);
				if (!bDefault) {
					ctx = null;
				} else if (viewNode != imageNode && (!reflection.isRevisionNode(viewNode) || !reflection.isMasterNode(imageNode))) {
					ctx = null;
				}
			}

			const enabled = this.inherited(arguments, [ctx]);

			this.dropDown.getChildren().forEach((menuItem) => {
				const menuLabel = menuItem[IMAGE_LABEL_ATTR];
				const isClear = menuLabel === IMAGE_LABEL_CLEAR;
				this._setChecked(menuItem, !isClear && labels.includes(menuLabel));
				this._setDisabled(menuItem, !enabled || (isClear && !labels.length));
			});
		},

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: set up menu items for each image label
			this.inherited(arguments);

			const {imageLabelStore, imageSpec} = this.actionToolbar.view;
			const {labelProperty} = imageLabelStore;
			const dd = this.dropDown = new Menu();
			let params;

			// support for ActionImage interface
			this.defAction.idAttr = imageSpec.heading.m_id;
			this.defAction.m_path = imageSpec.heading.m_path;

			imageLabelStore.query().forEach(function(item) {
				var key = xml.enumGetText(imageLabelStore.getIdentity(item));
				if (key && item[labelProperty]) {
					params = {
						"class": "csi-menu-item-with-icon",
						label: _.escape(item[labelProperty]),
						pluginName: this.pluginName,
						iconClass: "csi-checked-menu-item-check",
						onClick: lang.hitch(this, this._onClickLabel, key)
					};

					params[IMAGE_LABEL_ATTR] = key;

					dd.addChild(new CheckedMenuItem(params));
				}
			}, this);

			dd.addChild(new MenuSeparator());

			params = {
				"class": "csi-menu-item-with-icon",
				label: _.escape(locale.resource("PropertyImageLabelNone")),
				title: locale.resource("PropertyImageLabelNone_TT"),
				pluginName: this.pluginName,
				onClick: lang.hitch(this, this._onClickLabel, IMAGE_LABEL_CLEAR)
			};

			params[IMAGE_LABEL_ATTR] = IMAGE_LABEL_CLEAR;
			dd.addChild(new MenuItem(params));
			dd.startup();
		},

		onClick: function() {
			// summary: do not invoke action when clicking drop-down
		},

		_onClickLabel: function(/*String*/key) {
			// summary: add label to current image - false key indicates to remove the label
			this.onChange((key == IMAGE_LABEL_CLEAR) ? false : key);
		}
	});
});